module.exports = __webpack_public_path__ + "img/bosh_variostyle_12s.68456092.jpg";